module.exports = document;